(function () {
    'use strict';

    angular
        .module('oddCampaignRespondentModule')
        .directive('oddCampaignRespondent', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope        = _.clone(boxTmplScope);
        directiveScope.addControl = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope','$state', '$controller', 'oddCampaignRespondentService',
                function ($rootScope, $scope,$state, $controller, oddCampaignRespondentService) {
                    // Box Template
                    
                    $scope.baseTemplatePath = '/app/shared/odd/campaignRespondent/oddCampaignRespondent.[Template].tpl.html';

                    $controller('BoxTmplController', { $scope: $scope });
                    $scope.ctxtCtrl = {};

                    $scope.goToRespondents = function (respondents) {
                        if (!$scope.boxContext.isReadyToPublish)
                            return;
                        $scope.clickOnBox({ respondents: respondents });
                    };

                    $scope.sendReminder = function (respondent) {
                        if (!_.isArray(respondent))
                            respondent = [respondent];
                        return oddCampaignRespondentService
                                .inviteRespondents($scope.boxContext.campaign.ODDBusinessUnitID, $scope.boxContext.campaign.ODDCampaignID, respondent);
                    };

                    $scope.removeRespondent = function (respondent) {
                        return oddCampaignRespondentService
                            .removeCampaignRespondent($scope.boxContext.campaign.ODDBusinessUnitID, $scope.boxContext.campaign.ODDCampaignID, respondent.ODDCampaignRespondentID)
                             .then(function () {
                                 $state.reload();
                             });
                    };
                }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();